import React, { useEffect, useMemo, useReducer, useState } from 'react';

import { SelectChangeEvent } from '@mui/material';

import i18n from 'i18next';

import LanguageSelectorShell from '../../../../pages/auth/components/auth-language-selector/LanguageSelectorShell';
import { Language } from '../../../../shared/constants';
import {
  LocalStorageKey,
  LocalStorageService,
} from '../../../../shared/storage/local-storage';
import { ILanguage } from '../../../../types/interfaces/language';

interface IErrorLanguageSelectorProps {
  className?: string;
}

const STATIC_LANGUAGES: ILanguage[] = [
  { id: 'lang-en', key: Language.en, title: 'English' },
  { id: 'lang-ru', key: Language.ru, title: 'Русский' },
  { id: 'lang-pl', key: Language.pl, title: 'Polski' },
  { id: 'lang-by', key: Language.by, title: 'Беларуская' },
  { id: 'lang-ua', key: Language.ua, title: 'Українська' },
];

const ErrorLanguageSelector = ({ className }: IErrorLanguageSelectorProps) => {
  const [i18nTick, rerender] = useReducer((n: number) => n + 1, 0);
  const [selectedKey, setSelectedKey] = useState('');

  useEffect(() => {
    const onLanguageChanged = () => {
      rerender();
    };
    i18n.on('languageChanged', onLanguageChanged);
    return () => {
      i18n.off('languageChanged', onLanguageChanged);
    };
  }, []);

  const i18nSelectedKey = useMemo(() => {
    const code = i18n.language?.split('-')[0] ?? '';
    return (
      STATIC_LANGUAGES.find((language) => language.key === code)?.key ??
      STATIC_LANGUAGES[0].key
    );
  }, [i18nTick]);

  useEffect(() => {
    setSelectedKey(i18nSelectedKey);
  }, [i18nSelectedKey]);

  const onChange = async (event: SelectChangeEvent<string>) => {
    const nextKey = event.target.value;
    if (!STATIC_LANGUAGES.some((language) => language.key === nextKey)) return;

    setSelectedKey(nextKey);
    LocalStorageService.setValue(LocalStorageKey.language, nextKey as Language);
    await i18n.changeLanguage(nextKey);
  };

  return (
    <LanguageSelectorShell
      languages={STATIC_LANGUAGES}
      selectedKey={selectedKey}
      onChange={onChange}
      className={className}
    />
  );
};

export default ErrorLanguageSelector;
